import { CatalogEntryCarouselSeeMoreContext } from '@/data/context/catalogEntryCarouselSeeMore';
import { useContext, useEffect } from 'react';

interface DpCatalogEntryCarouselSeeMoreProps {
	id: string;
	href: string;
}

export const DpCatalogEntryCarouselSeeMore: React.FC<DpCatalogEntryCarouselSeeMoreProps> = ({
	id,
	href,
}) => {
	const { setEntryCarouselSeeMore } = useContext(CatalogEntryCarouselSeeMoreContext);

	useEffect(() => {
		setEntryCarouselSeeMore((prev) => ({ ...prev, [id]: href }));
	}, [href, id, setEntryCarouselSeeMore]);

	return null;
};
